import { OnboardingToolbar } from './OnboardingToolbar';
import { Multiselect, MultiselectOption } from '../../commons/components/Multiselect';
import React, { useState } from 'react';
import { useFetchedPromptVariables } from '../../growegy-ai/variables/hooks/useFetchedPromptVariables';
import { ONBOARDING_STEP_GOAL, OnboardingStepAnswer } from '../types';
import _ from 'lodash';
import { useOnboardingWizardStepAnalyticsPage } from '../hooks/useOnboardingWizardStepAnalyticsPage';

const GOALS: MultiselectOption[] = [
  { text: 'Build business credit', code: 'business-credit' },
  { text: 'Get organized', code: 'get-organized' },
  { text: 'Obtain a SBA loan', code: 'sba-loan' },
  { text: 'Build business plan', code: 'business-plan' },
  { text: 'Use AI for marketing content', code: 'ai-content' },
];

const OTHER_GOAL: MultiselectOption = { text: 'Other', code: 'other' };

export const GoalStep = (props: {
  stepIndex: number;
  totalSteps: number;
  onNext: (answers: OnboardingStepAnswer[]) => void;
  onSkip: () => void;
}) => {
  useOnboardingWizardStepAnalyticsPage(ONBOARDING_STEP_GOAL);
  const { stepIndex, totalSteps, onNext, onSkip } = props;
  const [goals, setGoals] = useState([..._.shuffle([...GOALS]), OTHER_GOAL]);
  const [comment, setComment] = useState<string>('');

  // Prefetch data for the next step.
  useFetchedPromptVariables();

  return (
    <div className="onboarding-step__container">
      <div className="onboarding-step__goal-question">
        What are your main goals? You can select more than one.
      </div>
      <div className="onboarding-step__container overflow-auto">
        <Multiselect options={goals} onOptionsChanged={setGoals} />
        <div className="onboarding-goal__comment-wrapper">
          <textarea
            className="onboarding-goal__comment"
            data-test="onboarding-goal__comment"
            placeholder="What are you other goals?"
            value={comment}
            maxLength={1024}
            onChange={(event) => {
              setComment(event.target.value);
            }}
          />
        </div>
      </div>
      <OnboardingToolbar
        stepIndex={stepIndex}
        totalSteps={totalSteps}
        nextDisabled={goals.every((x) => !x.isSelected)}
        onNext={() =>
          onNext([
            {
              name: 'goals',
              value: goals
                .filter((x) => x.isSelected)
                .map((x) => x.code)
                .join(','),
            },
            ...(comment.trim().length > 0 ? [{ name: 'comment', value: comment }] : []),
          ])
        }
        onSkip={onSkip}
      />
    </div>
  );
};
